import styled from 'styled-components'

export const Blog = styled.div`
  padding: 40px 0;
  background: #fff;

  .title {
    text-decoration: none;
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    :hover {
      svg {
        margin-left: 30px;
      }
    }

    span {
      font-size: 36px;
      font-weight: 900;
      color: #000;
      text-align: left;
    }

    svg {
      margin-left: 20px;
      transition: all 0.3s;
      width: 31px;
      height: 31px;
    }
  }

  .last-posts {
    &__title {
      font-size: 24px;
      font-weight: 900;
      margin-bottom: 0px;
    }

    &__grid {
      display: flex;
      margin-left: -10px;
      margin-right: -10px;

      > div {
        margin: 10px;
      }

      > div:nth-child(1) {
        flex: 5;
      }

      > div:nth-child(2), > div:nth-child(3) {
        flex: 2.5;
      }
    }
  }

  .post {
    > a {
      width: 100%;
      text-decoration: none;
      transition: all 0.3s;
      float: left;
      
      .post__image-feature {
        margin-top: 10px;
        transition: all 0.3s;
      }
      
      &:hover {
        margin-bottom: 10px;

        .post__image-feature {
          margin-top: 0px;
        }

        .post__title {
          color: var(--color-primary);
        }
      }
    }

    &:nth-child(1) .post__image-feature {
      height: 320px;
    }

    &:nth-child(2) .post__image-feature , &:nth-child(3) .post__image-feature {
      height: 170px;
    }

    &__image-feature {
      width: 100%;
      border-radius: 6px;
      margin-bottom: 20px;
      background-size: cover;
      background-position: center; 
    }

    &__title {
      font-size: 22px;
      font-weight: 700;
      color: #000;
      line-height: 22px;
      margin-bottom: 15px;
    }

    &__posted {
      color: #4F4F4F;
      
      strong {
        font-weight: 700;
      }
    } 
  }

  @media screen and (max-width: 1000px) {
    padding: 50px 0;

    .title {
      span {
        font-size: 24px;
      }

      svg {
        width: 18px;
        height: 18px;
      }
    }

    .last-posts {
      &__grid {
        flex-direction: column;
      }

      &__title {
        font-size: 18px;
      }
    }

    .post {
      margin-bottom: 20px !important;

      &__image-feature {
        height: 220px !important;
        margin-bottom: 10px;
      }

      &__title {
        font-size: 20px;
        line-height: 22px;
        margin-bottom: 5px;
      }
    }
  }
`